<template>
  <span v-if="!isSvgIcon"
        :class="iconClass"
        :data-placement="hasTooltip ? 'bottom' : null"
        :data-toggle="hasTooltip ? 'tooltip' : null"
        :title="hasTooltip ? (title ? title : icons[type].tooltip) : null"
        @click="$emit('click', $event)">
  </span>
  <img v-else
       :class="iconClass"
       :data-placement="hasTooltip ? 'bottom' : null"
       :data-toggle="hasTooltip ? 'tooltip' : null"
       :src="icons[type].path"
       :title="hasTooltip ? (title ? title : icons[type].tooltip) : null"
       @click="$emit('click', $event)"/>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    hasTooltip: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  computed: {
    iconClass() {
      if (!this.icon) {
        return {};
      }
      return {
        'nevron-icon': true,
        'svg': this.isSvgIcon,
        [this.type]: true,
        [this.icon.code]: (this.icon && this.icon.code),
      };
    },
    icon() {
      return this.icons[this.type];
    },
    isSvgIcon() {
      return this.icon && this.icon.path;
    }
  },
  data() {
    return {
      icons: {
        remove: {code: 'fas fa-trash-alt', tooltip: 'Remove'},
        edit: {code: 'fas fa-edit', tooltip: 'Edit'},
        unlink: {code: 'fas fa-times text-danger', tooltip: 'Unlink'},
        import: {code: 'fas fa-upload', tooltip: 'Import'},
        export: {code: 'fas fa-download', tooltip: 'Export'},
        refresh: {code: 'fas fa-sync', tooltip: 'Refresh'},
        copy: {code: 'far fa-copy', tooltip: 'Copy'},
        copied: {code: 'fas fa-copy', tooltip: 'Copied'},
        add: {code: 'fas fa-plus', tooltip: 'Add'},
        right: {code: 'fas fa-arrow-right', tooltip: 'Right Arrow'},
        left: {code: 'fas fa-arrow-left', tooltip: 'Left Arrow'},
        back: {code: 'fas fa-chevron-left', tooltip: 'Back Arrow'},
        dotHandle: {code: 'fas fa-grip-vertical', tooltip: 'Sort Handle'},
        sidebarItemInactive: {code: 'fas fa-info-circle', tooltip: 'Inactive'},
        fix: {code: 'fas fa-wrench', tooltip: 'Fix'},
        erase: {code: 'fas fa-eraser', tooltip: 'Erase'},
        ping: {code: 'fas fa-network-wired', tooltip: 'Ping'},
        reboot: {code: 'fas fa-redo', tooltip: 'Reboot'},
        reset: {code: 'fas fa-sync', tooltip: 'Reset'},
        load: {code: 'fas fa-spinner', tooltip: 'Load'},

        // SVG Icons
        accessRoles: {
          path: require('@/assets/icons/white/access_roles-w.svg'),
          tooltip: 'Access Roles'
        },
        aod: {path: require('@/assets/icons/white/aod-w.svg'), tooltip: 'AOD'},
        apps: {path: require('@/assets/icons/white/apps-w.svg'), tooltip: 'Apps'},
        webLinks: {path: require('@/assets/icons/white/web_links-w.svg'), tooltip: 'Web Links'},
        tvApps: {path: require('@/assets/icons/white/tv-apps-w.svg'), tooltip: 'TV Apps'},
        cast: {path: require('@/assets/icons/white/cast-w.svg'), tooltip: 'Cast'},
        cart: {path: require('@/assets/icons/white/cart.svg'), tooltip: 'Cart'},
        catalogues: {path: require('@/assets/icons/white/catalogues-w.svg'), tooltip: 'Catalogues'},
        customer: {path: require('@/assets/icons/white/customer-w.svg'), tooltip: 'Customers'},
        dashboard: {path: require('@/assets/icons/white/dashboards-w.svg'), tooltip: 'Dashboard'},
        digitalSignage: {
          path: require('@/assets/icons/white/digital_signage-w.svg'),
          tooltip: 'Digital Signage'
        },
        digitalSignageMenu: {
          path: require('@/assets/icons/white/digital_signage-menu-w.svg'),
          tooltip: 'Digital Signage'
        },
        weather: {
          path: require('@/assets/icons/white/weather_icon-w.svg'),
          tooltip: 'Weather'
        },
        welcomeScreen: {
          path: require('@/assets/icons/white/welcome_screen-w.svg'),
          tooltip: 'Welcome Screen'
        },
        screenPortrait: {
          path: require('@/assets/icons/black/rectangle-portrait.svg'),
          tooltip: 'Portrait'
        },
        screenLandscape: {
          path: require('@/assets/icons/black/rectangle-landscape.svg'),
          tooltip: 'Landscape'
        },
        essentials: {path: require('@/assets/icons/white/essentials-w.svg'), tooltip: 'Essentials'},
        fastCheckIn: {
          path: require('@/assets/icons/white/fast_check_in-w.svg'),
          tooltip: 'Fast Check In'
        },
        home: {path: require('@/assets/icons/white/home-w.svg'), tooltip: 'Home'},
        liveCameras: {
          path: require('@/assets/icons/white/live_cameras-w.svg'),
          tooltip: 'Live Cameras'
        },
        location: {path: require('@/assets/icons/white/location-w.svg'), tooltip: 'Location'},
        mediaLibrary: {
          path: require('@/assets/icons/white/media_library-w.svg'),
          tooltip: 'Media Library'
        },
        mobile: {path: require('@/assets/icons/white/mobile-b.svg'), tooltip: 'Mobile'},
        myMood: {path: require('@/assets/icons/white/my_mood-w.svg'), tooltip: 'My Mood'},
        myMoodBlack: {path: require('@/assets/icons/black/my_mood-b.svg'), tooltip: 'My Mood'},
        scheduled: {path: require('@/assets/icons/black/scheduled-b.svg'), tooltip: 'Scheduled'},
        notifications: {
          path: require('@/assets/icons/white/notifications-w.svg'),
          tooltip: 'Notifications'
        },
        occupancyRate: {
          path: require('@/assets/icons/white/occupancy-rate-w.svg'),
          tooltip: 'Occupancy Rate'
        },
        activeGuests: {
          path: require('@/assets/icons/white/active-guest-w.svg'),
          tooltip: 'Active Guests'
        },
        skipCleaning: {
          path: require('@/assets/icons/white/skip-cleaning-w.svg'),
          tooltip: 'Skip Cleaning'
        },
        averageStays: {
          path: require('@/assets/icons/white/average-stay-w.svg'),
          tooltip: 'Average Stays'
        },
        packages: {path: require('@/assets/icons/white/packages-w.svg'), tooltip: 'Packages'},
        property: {path: require('@/assets/icons/white/property-w.svg'), tooltip: 'Property'},
        roomCare: {path: require('@/assets/icons/white/room_care-w.svg'), tooltip: 'Room Care'},
        settings: {path: require('@/assets/icons/white/settings-w.svg'), tooltip: 'Settings'},
        survey: {path: require('@/assets/icons/white/survey-w.svg'), tooltip: 'Survey'},
        surveyBlack: {path: require('@/assets/icons/black/survey-b.svg'), tooltip: 'Survey'},
        tv: {path: require('@/assets/icons/white/tv-w.svg'), tooltip: 'TV Channels'},
        tvBlack: {path: require('@/assets/icons/white/tv-b.svg'), tooltip: 'TV'},
        userSettings: {path: require('@/assets/icons/white/user-settings-w.svg'), tooltip: 'User Settings'},
        vod: {path: require('@/assets/icons/white/vod-w.svg'), tooltip: 'VOD'},
        widgets: {path: require('@/assets/icons/white/widgets-w.svg'), tooltip: 'Widgets'},
        video: {path: require('@/assets/icons/white/sod-w.svg'), tooltip: 'SOD'},
        shipPosition: {path: require('@/assets/icons/white/ship_position-w.svg'), tooltip: 'Ship Position'},
        currencyExchange: {path: require('@/assets/icons/white/currency_icon_manager_white.svg'), tooltip: 'Currency Exchange'},
        instructions: {path: require('@/assets/icons/black/instructions-b.svg'), tooltip: 'Ship Position'},
        mostVisitedPages: {path: require('@/assets/icons/white/most_visited_pages-w.svg'), tooltip: 'Page Visited'},
        country: {path: require('@/assets/icons/white/country-w.svg'), tooltip: 'country'},
        searchFilter: {path: require('@/assets/icons/black/filter.svg'), tooltip: 'Search filter'},

      },
    };
  },
};
</script>
